import { BaseRestRepository } from './baseRestRepository';
import type { SendResultDto } from '~/swagger/portal/Api';

const AUTH_URL = '/api/auth';

export class AuthRepository extends BaseRestRepository {
  public async getResetPasswordEmail(data: { email: string; companyId?: string }): Promise<SendResultDto> {
    const response = await this.fetchWithoutAuth(`${AUTH_URL}/recover-password`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }
}

export const authRepository = new AuthRepository();
